/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signuptypelongtext3Inputs */

const en_signuptypelongtext3 = /** @type {(inputs: Signuptypelongtext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long text`)
};

const de_signuptypelongtext3 = /** @type {(inputs: Signuptypelongtext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langer Text`)
};

/**
* | output |
* | --- |
* | "Long text" |
*
* @param {Signuptypelongtext3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuptypelongtext3 = /** @type {((inputs?: Signuptypelongtext3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuptypelongtext3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuptypelongtext3(inputs)
	return de_signuptypelongtext3(inputs)
});
export { signuptypelongtext3 as "signupTypeLongText" }